import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
//components
import { SidebarButton } from './styles';
import CustomSlider from '../CustomSlider';
import SidebarContent from '../SidebarContent';
import { Visibility } from 'components/Visibility';
import { useCustomEvent } from 'components/ApplicationInsights';
import { eventName, portalDashboardAction } from 'components/ApplicationInsights/eventNames';
//assets
import openSidebarIcon from 'img/open-sidebar-icon.svg';

interface ISidebarItems {
  className?: string;
}

const Sidebar: React.FC<ISidebarItems> = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const componentName = `Sidebar button`;
  const trackMenuClick = useCustomEvent(componentName, eventName.SIDEBAR_PORTAL);

  const handleOpenSidebar = () => {
    if (portalDashboardAction.MENU_PORTAL) {
      trackMenuClick({ item: portalDashboardAction.MENU_PORTAL });
    }

    dispatch({
      type: 'OPEN_CUSTOM_SLIDER',
      data: {
        show: true,
        content: SidebarContent,
      },
    });
  };

  const portalRoutes = ['cotacoes-dashboard', 'cotacoes-nova', 'gravado-no-money', 'de-para', 'relatorios-portal', 'baixa-manual', 'bi-portal', 'skus-prioritarios'];
  const pathName = location.pathname.split("/")[1];

  return (
    <>
      <Visibility visible={portalRoutes.includes(pathName)}>
        <CustomSlider />
        <SidebarButton
          trackName={portalDashboardAction.MENU_PORTAL}
          onClick={handleOpenSidebar}
        >
          <img src={openSidebarIcon} alt="open sidebar icon" />
        </SidebarButton>
      </Visibility>
    </>
  );
};

export default Sidebar;
